module.exports = __webpack_public_path__ + "img/ivy_house_logo_whiteonblack.289cfe85.png";